import styled from 'styled-components';
import { BulletedList as BulletedListBase } from '../../../../ToolkitV2/BulletedList/BulletedList';
import { LinkButton } from 'toolkit';
import { Text } from '../../../../ToolkitV2/Text/Text';

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const InfoIconButton = styled(LinkButton)`
  padding: 12px; // Makes the touch area 44px x 44px. 20px + 12px + 12px
  margin: -12px; // Compensates the layout for the increased touch area padding to keep the elements aligned
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1; // Ensures the buttons expanded touch area is above other elements for better clickability
`;

const BulletedList = styled(BulletedListBase)`
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
`;

const OpeningText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export { Header, OpeningText, BulletedList, InfoIconButton };
